import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment.development';
import { SseClient } from 'ngx-sse-client';
import { Observable, of } from 'rxjs';

export interface TimeEntry {
  weId: number;
  rtTicketId: string | null;
  ticket: string | null;
  comment: string | null;
  startTime: number;
  endTime: number;
}

export function isTimeEntry(entry: TimeEntry | {}): entry is TimeEntry {
  return (entry as TimeEntry).weId !== undefined;
}

@Injectable({
  providedIn: 'root',
})
export class TimerApiService {
  private sseClient = inject(SseClient);
  http = inject(HttpClient);

  private url = environment.serverUrl + '/workedentry/timer';

  getTimerEventStream() {
    const stream = this.sseClient.stream(
      this.url + '/emitter',
      {
        responseType: 'event',
      },
      {
        withCredentials: true,
      }
    ) as Observable<MessageEvent<string>>;

    //TODO Mock data
    return of(
      new MessageEvent('test-event', {
        data: { test: 2 },
        origin: 'event.origin',
        lastEventId: 'event.lastEventId',
      })
    );
    //   return stream.pipe(
    //     map((event) => {
    //       return new MessageEvent(event.type, {
    //         data: JSON.parse(event.data),
    //         origin: event.origin,
    //         lastEventId: event.lastEventId,
    //       });
    //     })
    //   ) as Observable<MessageEvent<unknown>>;
  }

  // Retrieve currently running accounting This is what the FE will call periodically
  getCurrentTimeEntry(): Observable<TimeEntry | {}> {
    return this.http.get<TimeEntry | {}>(`${this.url}/current`, {
      withCredentials: true,
    });
  }
}
